import React from 'react';
import { Toaster, toast } from 'react-hot-toast';

const ToastNotification: React.FC = () => {
  return <Toaster />;
};

export const showToast = (message: string, type: 'success' | 'error' | 'loading' | 'custom', duration: number = 3000) => {
  switch (type) {
    case 'success':
      toast.success(message, { duration });
      break;
    case 'error':
      toast.error(message, { duration });
      break;
    case 'loading':
      toast.loading(message, { duration });
      break;
    case 'custom':
      toast(message, { duration });
      break;
    default:
      toast(message, { duration });
      break;
  }
};

export default ToastNotification;
